import type { ReactNode } from 'react'
import { GoogleOAuthProvider } from '@react-oauth/google'
import { AuthProvider } from '@/contexts/AuthContext'
import { CartProvider } from '@/contexts/CartContext'
import { CurrencyProvider } from '@/contexts/CurrencyContext'
import { I18nProvider } from '@/contexts/I18nContext'

interface AppProvidersProps {
  children: ReactNode
}

const googleClientId = import.meta.env.VITE_GOOGLE_CLIENT_ID || 'mock-google-client-id'

const AppProviders = ({ children }: AppProvidersProps) => (
  <GoogleOAuthProvider clientId={googleClientId}>
    <AuthProvider>
      <I18nProvider>
        <CurrencyProvider>
          <CartProvider>{children}</CartProvider>
        </CurrencyProvider>
      </I18nProvider>
    </AuthProvider>
  </GoogleOAuthProvider>
)

export default AppProviders